// import React, { useState, useContext } from "react";
// import { UrlContext } from "../../../contexts/UrlContext";
// import Swal from "sweetalert2";

// export default function DiclineProfile({
//   projectID,
//   profile,
//   setShowDecline,
//   setIsAccepted,
//   setIsDeclined,
//   clickingOnProfile
// }) {
//   const isDownloaded = "/pictures/";
//   const { API_URL } = useContext(UrlContext);

//   const [experience, setExperience] = useState(null);
//   const [cost, setCost] = useState(null);
//   const [location, setLocation] = useState(null);
//   const [others, setOthers] = useState(null);
//   const [openOthers, setOpenOthers] = useState(false);
//   const [feedbackToEph, setFeedbackToEph] = useState(null);

//   // API for selecting a consultant
//   const declineConsultantForCall = async () => {
//     const reasoning = [experience, cost, location, others];

//     const selectedReasons = reasoning.filter(Boolean);
//     let reasonText = "";
//     if (selectedReasons.length === 1) {
//       reasonText = selectedReasons[0];
//     } else if (selectedReasons.length === 2) {
//       reasonText = `${selectedReasons[0]} and ${selectedReasons[1]}`;
//     } else if (selectedReasons.length > 2) {
//       reasonText = `${selectedReasons.slice(0, -1).join(", ")}, and ${selectedReasons.slice(-1)}`;
//     }

//     const requestBody = {
//       projectID: projectID,
//       expertID: profile.expertID,
//       reasons: reasoning,
//       feedbackToEph: feedbackToEph,
//       client: true,
//     };
//     try {
//       let modifiedUrl = "decline-consultant-for-call";
//       const response = await fetch(`${API_URL}${modifiedUrl}`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(requestBody),
//       });
//       const responseData = await response.json();
//       if (responseData.status === "success") {
//         clickingOnProfile(profile.expertID, 'Client declined profile');
//         if (reasonText.length>0) {
//           clickingOnProfile(profile.expertID, `Client mentioned ${reasonText} as declining reason`);
//         };
//         setShowDecline(false);
//         setIsAccepted(false);
//         setIsDeclined(true);
//       } else {
//         console.error("Failed to add selected consultant");
//         setShowDecline(false);
//         Swal.fire({
//           title: "Error!",
//           text: "Unexpected error!",
//           icon: "error",
//           confirmButtonText: "OK",
//         });
//       }
//     } catch (error) {
//       setShowDecline(false);
//       console.error("Error while calling the backend API:", error);
//       Swal.fire({
//         title: "Error!",
//         text: "Unexpected error!",
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//     }
//   };

//   return (
//     <>
//       <div className="decline-wrapper">
//         <div
//           className="flex-container-decline-profile"
//           style={{ padding: "0px" }}
//         >
//           <div
//             className="flex-item-decline-profile-header"
//             style={{ flex: "5%", backgroundColor: "#365561" }}
//           >
//             <p
//               style={{
//                 fontSize: "16px",
//                 fontWeight: "500",
//                 marginLeft: "5px",
//                 color: "white",
//               }}
//             >
//               Decline Consultant
//             </p>
//             <i
//               class="fa-solid fa-xmark"
//               style={{
//                 marginRight: "5px",
//                 marginTop: "3px",
//                 color: "gray",
//                 cursor: "pointer",
//               }}
//               onClick={() => setShowDecline(false)}
//             />
//           </div>

//           <div
//             className="flex-item-dicline-profile"
//             style={{
//               flex: "95%",
//               display: "flex",
//               flexDirection: "column",
//               overflowY: "auto",
//             }}
//           >
//             <div
//               className="flex-item-decline-profile-content"
//               style={{ flex: "70%", padding: "5px" }}
//             >
//               <div>
//                 {profile.expertProfilePicture ? (
//                   <>
//                     <div style={{ textAlign: "center", padding: "5px" }}>
//                       {profile.expertProfilePicture.includes(isDownloaded) ? (
//                         <img
//                           src={`https://images.expertpowerhouse.com${profile.expertProfilePicture}`}
//                           style={{
//                             width: "50px",
//                             height: "50px",
//                             borderRadius: "50%",
//                           }}
//                         />
//                       ) : (
//                         <img
//                           src={profile.expertProfilePicture}
//                           width={"50px"}
//                           alt=""
//                         />
//                       )}
//                     </div>
//                   </>
//                 ) : (
//                   <>
//                     <div style={{ textAlign: "center", padding: "5px" }}>
//                       <img
//                         src={`https://images.expertpowerhouse.com${"/pictures/dummy.png"}`}
//                         style={{
//                           width: "50px",
//                           height: "50px",
//                           borderRadius: "50%",
//                         }}
//                       />
//                     </div>
//                   </>
//                 )}
//               </div>
//               <h5 style={{ textAlign: "center" }}>
//                 What are your reasons for declining this Consultant?
//               </h5>

//               <div className="declining-reason-from-client">
//                 {experience ? (
//                   <button
//                     onClick={() => setExperience(null)}
//                     style={{
//                       background: "#365561",
//                       color: "white",
//                       outline: "none",
//                       padding: "0px 10px 2px 10px",
//                     }}
//                   >
//                     Experience
//                   </button>
//                 ) : (
//                   <button
//                     onClick={() => setExperience("Experience")}
//                     style={{ outline: "none", padding: "0px 10px 2px 10px" }}
//                   >
//                     Experience
//                   </button>
//                 )}
//                 {cost ? (
//                   <button
//                     onClick={() => setCost(null)}
//                     style={{
//                       background: "#365561",
//                       color: "white",
//                       outline: "none",
//                       padding: "0px 10px 2px 10px",
//                     }}
//                   >
//                     Cost
//                   </button>
//                 ) : (
//                   <button
//                     onClick={() => setCost("Cost")}
//                     style={{ outline: "none", padding: "0px 10px 2px 10px" }}
//                   >
//                     Cost
//                   </button>
//                 )}
//                 {location ? (
//                   <button
//                     onClick={() => setLocation(null)}
//                     style={{
//                       background: "#365561",
//                       color: "white",
//                       outline: "none",
//                       padding: "0px 10px 2px 10px",
//                     }}
//                   >
//                     Location/Availablity
//                   </button>
//                 ) : (
//                   <button
//                     onClick={() => setLocation("Location/Availablity")}
//                     style={{ outline: "none", padding: "0px 10px 2px 10px" }}
//                   >
//                     Location/Availablity
//                   </button>
//                 )}
//                 {openOthers ? (
//                   <button
//                     onClick={() => {
//                       setOpenOthers(false);
//                       setOthers(null);
//                     }}
//                     style={{
//                       background: "#365561",
//                       color: "white",
//                       outline: "none",
//                       padding: "0px 10px 2px 10px",
//                     }}
//                   >
//                     Others
//                   </button>
//                 ) : (
//                   <button
//                     onClick={() => setOpenOthers(true)}
//                     style={{ outline: "none", padding: "0px 10px 2px 10px" }}
//                   >
//                     Others
//                   </button>
//                 )}
//               </div>

//               {openOthers && (
//                 <div style={{ textAlign: "center", marginTop: "40px" }}>
//                   <p style={{ fontSize: "15px", fontWeight: "500" }}>
//                     Please tell us the reason for declining!
//                   </p>
//                   <div
//                     style={{ padding: "5px", border: "1px solid lightgrey" }}
//                   >
//                     <textarea
//                       className="note-for-consultent-from-client"
//                       placeholder="The reason for declining this consultant..."
//                       value={others}
//                       onChange={(e) => setOthers(e.target.value)}
//                     />
//                   </div>
//                 </div>
//               )}
//             </div>

//             <div
//               className="flex-item-decline-profile-content"
//               style={{ flex: "20%", padding: "5px" }}
//             >
//               <div style={{ textAlign: "center" }}>
//                 <p style={{ fontSize: "15px", fontWeight: "500" }}>
//                   Add feedback to the EPH Project Manager.
//                 </p>
//                 <div style={{ padding: "5px", border: "1px solid lightgrey" }}>
//                   <textarea
//                     className="note-for-consultent-from-client"
//                     placeholder="The candidate wasn't a fit because..."
//                     value={feedbackToEph}
//                     onChange={(e) => setFeedbackToEph(e.target.value)}
//                   />
//                 </div>
//               </div>
//             </div>

//             <div
//               className="flex-item-decline-profile-action-bar"
//               style={{ flex: "5%" }}
//             >
//               <div
//                 className="decline-consultant-action-button"
//                 style={{ display: "flex", justifyContent: "flex-end" }}
//               >
//                 <button
//                   className="cancel-decline-button"
//                   onClick={() => setShowDecline(false)}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   className="decline-button"
//                   onClick={() => declineConsultantForCall()}
//                   style={{ background: "#365561", color: "white" }}
//                 >
//                   Decline Consultant
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }


import React, { useState, useContext } from "react";
import { UrlContext } from "../../../contexts/UrlContext";
import Swal from "sweetalert2";

export default function DiclineProfile({
  projectID,
  profile,
  setShowDecline,
  setIsAccepted,
  setIsDeclined,
  clickingOnProfile,
}) {
  const isDownloaded = "/pictures/";
  const { API_URL } = useContext(UrlContext);

  const [experience, setExperience] = useState(null);
  const [cost, setCost] = useState(null);
  const [location, setLocation] = useState(null);
  const [others, setOthers] = useState(null);
  const [openOthers, setOpenOthers] = useState(false);
  const [feedbackToEph, setFeedbackToEph] = useState(null);

  const fallbackProfilePicture =
    "https://images.expertpowerhouse.com/pictures/dummy.png";

  const profilePictureUrl = profile?.expertProfilePicture
    ? profile.expertProfilePicture.includes(isDownloaded)
      ? `https://images.expertpowerhouse.com${profile.expertProfilePicture}`
      : profile.expertProfilePicture
    : fallbackProfilePicture;

  const reasonOptions = [
    {
      label: "Experience",
      value: experience,
      setValue: setExperience,
      selectedValue: "Experience",
    },
    {
      label: "Cost",
      value: cost,
      setValue: setCost,
      selectedValue: "Cost",
    },
    {
      label: "Location/Availability",
      value: location,
      setValue: setLocation,
      selectedValue: "Location/Availablity",
    },
  ];

  // API for selecting a consultant
  const declineConsultantForCall = async () => {
    const reasoning = [experience, cost, location, others];

    const selectedReasons = reasoning.filter(Boolean);
    let reasonText = "";
    if (selectedReasons.length === 1) {
      reasonText = selectedReasons[0];
    } else if (selectedReasons.length === 2) {
      reasonText = `${selectedReasons[0]} and ${selectedReasons[1]}`;
    } else if (selectedReasons.length > 2) {
      reasonText = `${selectedReasons.slice(0, -1).join(", ")}, and ${selectedReasons.slice(-1)}`;
    }

    const requestBody = {
      projectID: projectID,
      expertID: profile.expertID,
      reasons: reasoning,
      feedbackToEph: feedbackToEph,
      client: true,
    };
    try {
      let modifiedUrl = "decline-consultant-for-call";
      const response = await fetch(`${API_URL}${modifiedUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const responseData = await response.json();
      if (responseData.status === "success") {
        clickingOnProfile(profile.expertID, "Client declined profile");
        if (reasonText.length > 0) {
          clickingOnProfile(
            profile.expertID,
            `Client mentioned ${reasonText} as declining reason`
          );
        }
        setShowDecline(false);
        setIsAccepted(false);
        setIsDeclined(true);
      } else {
        console.error("Failed to add selected consultant");
        setShowDecline(false);
        Swal.fire({
          title: "Error!",
          text: "Unexpected error!",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      setShowDecline(false);
      console.error("Error while calling the backend API:", error);
      Swal.fire({
        title: "Error!",
        text: "Unexpected error!",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/45 px-3 py-4 backdrop-blur-sm sm:px-5">
      <div
        className="
          grid max-h-[92vh] w-full max-w-3xl grid-rows-[auto_minmax(0,1fr)_auto]
          overflow-hidden rounded-3xl border border-white/60 bg-white shadow-[0_24px_80px_rgba(15,23,42,0.28)]
        "
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className="
            grid grid-cols-[minmax(0,1fr)_auto] items-center gap-3
            bg-[#365561] px-4 py-3 text-white sm:px-5
          "
        >
          <div className="min-w-0">
            <p className="truncate text-base font-semibold sm:text-lg">
              Decline Consultant
            </p>
            <p className="mt-0.5 hidden truncate text-xs text-white/75 sm:block">
              Share the reason so the EPH team can improve future matches.
            </p>
          </div>

          <button
            type="button"
            onClick={() => setShowDecline(false)}
            className="
              inline-flex h-9 w-9 items-center justify-center rounded-full
              bg-white/10 text-white transition hover:bg-white/20 focus:outline-none
            "
            aria-label="Close decline dialog"
          >
            <i className="fa-solid fa-xmark text-base" />
          </button>
        </div>

        <div className="min-h-0 overflow-y-auto px-4 py-4 sm:px-5 sm:py-5">
          <div className="grid min-w-0 grid-cols-1 gap-4 md:grid-cols-[auto_minmax(0,1fr)] md:items-center">
            <div className="flex justify-center md:justify-start">
              <img
                src={profilePictureUrl}
                alt=""
                className="h-16 w-16 rounded-2xl bg-[#365561] object-cover shadow-sm sm:h-20 sm:w-20"
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = fallbackProfilePicture;
                }}
              />
            </div>

            <div className="min-w-0 text-center md:text-left">
              <h5 className="text-base font-semibold text-slate-900 sm:text-lg">
                What are your reasons for declining this consultant?
              </h5>
              <p className="mt-1 text-sm leading-5 text-slate-500">
                Select one or more reason categories. You can also add a short note for the project manager.
              </p>
            </div>
          </div>

          <div className="mt-5 grid grid-cols-2 gap-2 sm:grid-cols-4">
            {reasonOptions.map((option) => {
              const isSelected = Boolean(option.value);

              return (
                <button
                  key={option.label}
                  type="button"
                  onClick={() =>
                    option.setValue(isSelected ? null : option.selectedValue)
                  }
                  className={[
                    "rounded-2xl border px-3 py-2 text-sm font-semibold transition focus:outline-none",
                    isSelected
                      ? "border-[#365561] bg-[#365561] text-white shadow-[0_10px_22px_rgba(54,85,97,0.22)]"
                      : "border-slate-200 bg-slate-50 text-slate-600 hover:border-[#365561]/40 hover:bg-[#365561]/5 hover:text-[#365561]",
                  ].join(" ")}
                >
                  {option.label}
                </button>
              );
            })}

            <button
              type="button"
              onClick={() => {
                if (openOthers) {
                  setOpenOthers(false);
                  setOthers(null);
                } else {
                  setOpenOthers(true);
                }
              }}
              className={[
                "rounded-2xl border px-3 py-2 text-sm font-semibold transition focus:outline-none",
                openOthers
                  ? "border-[#365561] bg-[#365561] text-white shadow-[0_10px_22px_rgba(54,85,97,0.22)]"
                  : "border-slate-200 bg-slate-50 text-slate-600 hover:border-[#365561]/40 hover:bg-[#365561]/5 hover:text-[#365561]",
              ].join(" ")}
            >
              Others
            </button>
          </div>

          <div className="mt-5 grid grid-cols-1 gap-4 md:grid-cols-2">
            {openOthers && (
              <div className="rounded-2xl border border-slate-200 bg-slate-50/70 p-3">
                <label className="text-sm font-semibold text-slate-700">
                  Reason for declining
                </label>
                <textarea
                  className="
                    mt-2 min-h-[118px] w-full resize-none rounded-2xl border border-slate-200
                    bg-white px-3 py-2 text-sm text-slate-700 outline-none
                    transition placeholder:text-slate-400 focus:border-[#365561] focus:ring-2 focus:ring-[#365561]/15
                  "
                  placeholder="The reason for declining this consultant..."
                  value={others || ""}
                  onChange={(e) => setOthers(e.target.value)}
                />
              </div>
            )}

            <div
              className={[
                "rounded-2xl border border-slate-200 bg-slate-50/70 p-3",
                openOthers ? "" : "md:col-span-2",
              ].join(" ")}
            >
              <label className="text-sm font-semibold text-slate-700">
                Feedback to the EPH Project Manager
              </label>
              <textarea
                className="
                  mt-2 min-h-[118px] w-full resize-none rounded-2xl border border-slate-200
                  bg-white px-3 py-2 text-sm text-slate-700 outline-none
                  transition placeholder:text-slate-400 focus:border-[#365561] focus:ring-2 focus:ring-[#365561]/15
                "
                placeholder="The candidate wasn't a fit because..."
                value={feedbackToEph || ""}
                onChange={(e) => setFeedbackToEph(e.target.value)}
              />
            </div>
          </div>
        </div>

        <div
          className="
            grid grid-cols-1 gap-2 border-t border-slate-200 bg-white/95 px-4 py-3
            sm:grid-cols-[auto_auto] sm:justify-end sm:px-5
          "
        >
          <button
            type="button"
            className="
              rounded-2xl border border-slate-200 bg-white px-4 py-2 text-sm font-semibold
              text-slate-600 transition hover:bg-slate-50 focus:outline-none
            "
            onClick={() => setShowDecline(false)}
          >
            Cancel
          </button>
          <button
            type="button"
            className="
              rounded-2xl bg-[#365561] px-4 py-2 text-sm font-semibold text-white
              shadow-[0_12px_24px_rgba(54,85,97,0.25)] transition hover:bg-[#2d4852] focus:outline-none
            "
            onClick={() => declineConsultantForCall()}
          >
            Decline Consultant
          </button>
        </div>
      </div>
    </div>
  );
}
